var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled from "styled-components";
import { get } from "lodash";
import id from "@irati/utils/id";
import FormattedMessage from "@irati/utils/lang";
import { IconTooltip } from "@irati/ui/src/Tooltip";
import { Para } from "@irati/ui/src/Labels";
var ExpandedPara = styled(Para)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  white-space: normal;\n  margin-bottom: 0;\n"], ["\n  white-space: normal;\n  margin-bottom: 0;\n"])));
var StyledTooltip = styled(IconTooltip)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-left: 5px;\n  vertical-align: text-bottom;\n"], ["\n  margin-left: 5px;\n  vertical-align: text-bottom;\n"])));
var NowrapSpan = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  white-space: nowrap;\n"], ["\n  white-space: nowrap;\n"])));
var PaddingSpan = styled.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding-left: 5px;\n"], ["\n  padding-left: 5px;\n"])));
var TeamsRenderer = /** @class */ (function (_super) {
    __extends(TeamsRenderer, _super);
    function TeamsRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getRemainingTeams = function (admins) {
            return admins.slice(2);
        };
        _this.getVisibleTeams = function (admins) {
            return admins.slice(0, 2);
        };
        return _this;
    }
    TeamsRenderer.prototype.render = function () {
        var idNamespace = id("TeamsRenderer", this.props);
        var row = this.props.row;
        var admins = get(row, "admins", []);
        var visibleTeams = this.getVisibleTeams(admins);
        var remainingTeams = this.getRemainingTeams(admins);
        return (React.createElement(ExpandedPara, { id: idNamespace },
            visibleTeams.join(", "),
            !!remainingTeams.length &&
                React.createElement(NowrapSpan, null,
                    React.createElement(PaddingSpan, null,
                        React.createElement(FormattedMessage, { id: "admin.reportingV2.admins.toolTipMoreText", values: { count: remainingTeams.length } })),
                    React.createElement(StyledTooltip, { icon: "dotDotDot" }, remainingTeams.join(", ")))));
    };
    return TeamsRenderer;
}(PureComponent));
export default TeamsRenderer;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
